export type Route = {
    id: string;
    text: string;
    system: string;
  }

export const RouteData: Route[] = [
  { id: '26643006', text: 'Oral route', system: 'http://snomed.info/sct' },
  { id: '127492001', text: 'Nasogastric route', system: 'http://snomed.info/sct' },
  { id: '225691000001105', text: 'Percutaneous endoscopic gastrostomy tube route', system: 'http://snomed.info/sct' },
  { id: '127490009', text: 'Gastrostomy route', system: 'http://snomed.info/sct' },
  { id: '445768003', text: 'Intragastric route', system: 'http://snomed.info/sct' },
  { id: '418114005', text: 'Intravenous central route', system: 'http://snomed.info/sct' },
  { id: '419993007', text: 'Intravenous peripheral route', system: 'http://snomed.info/sct' },
  { id: '47625008', text: 'Intravenous route (qualifier value)', system: 'http://snomed.info/sct' },
  { id: '46713006', text: 'Nasal route (qualifier value)', system: 'http://snomed.info/sct' },
  { id: '34206005', text: 'Subcutaneous route (qualifier value)', system: 'http://snomed.info/sct' },
  { id: '78421000', text: 'Intramuscular route (qualifier value)', system: 'http://snomed.info/sct' },
  { id: '37161004', text: 'Rectal route (qualifier value)', system: 'http://snomed.info/sct' },
  { id: '6064005', text: 'Topical route (qualifier value)', system: 'http://snomed.info/sct' }
  ];